import React from "react";
import Table from "material-ui/Table";
import { TableBody, TableCell, TableHead, TableRow } from "material-ui/Table";
import Paper from "material-ui/Paper";

export default function RegisteredUsers({ values }) {
  return (
    <div>
      <div className="block-registered-user">
        <div className="webinar-registered-users">
          Number of registered users
        </div>
        <div className="webinar-register-users">
          <span>({values.length})</span>
        </div>
      </div>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {values.map((value) => (
              <TableRow>
                <TableCell>{value.full_name}</TableCell>
                <TableCell>{value.email}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Admin/Webinar/RegisteredUsers.jsx